module.exports = __webpack_public_path__ + "static/mongo.9a8e6f82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/about/mongo.svg
// module id = 691
// module chunks = 263791100135453